export default __webpack_public_path__ + "static/media/hero.61dada00.png";